import { nanoid } from 'nanoid';
import { ACTION_TYPES } from '../../../../components/UI/MDC/DataTable/_types';
import { prettyDateFormat } from '../../../../utils/strings/StringUtil';

export const applicationSet = new Set();
export var APP_IDENTIFIER_TYPES = {
	All: 'All',
};
// Return application name without the action and generate list of unique applications
const getAppNameWithoutAction = application => {
	applicationSet.add(application);

	APP_IDENTIFIER_TYPES[application] = application;
	// Returns application name which does not have action attached
	return application;
};

/**
 * Function takes a @param {object} from the WorkQueue API
 *
 * @returns {Array} array of rows objects for the data table component.
 */
/**
 * Takes an object of specific format and returns an array of rows for the datatable component
 *
 * @function
 * @param {Object} requestData object returned from the WorkQueue API
 * @param {Object} dataCorrelation object with keys that maps to object returned from WorkQueue API
 * @param {Array} nonActionable array of tracking numbers which are not actionable
 * @returns {Array} array of rows objects for the data table component.
 */
export const generateRowData = (requestData, dataCorrelation) => {
	// Reset APP_IDENTIFIER_TYPES to default 'All' filter
	APP_IDENTIFIER_TYPES = { All: 'All' };
	var rowData = [
		// ActionCells = [],
		// Cells = undefined,
		// key: nanoid,
		// isDisplayed: true
	];

	// mainLevel keys
	var mainLevelKeys = Object.keys(dataCorrelation.mainLevel);
	var mainLevelValues = Object.values(dataCorrelation.mainLevel);

	// subLevel keys
	var subLevelKeys = Object.keys(dataCorrelation.subLevel);
	var subLevelValues = Object.values(dataCorrelation.subLevel);
	// const mySet = new Set();
	requestData.forEach(item => {
		// Initiate empty Cells object
		let Cells = {
			Action: '',
			Application: '',
			'Queue Name': '',
			ApplicationID: '',
			WorkQueueID: '',
			ItemID: '',
			Unactionable: '',
		};

		// Map through main level
		// Only need to do this once per request, since there can be many applications per request array
		mainLevelKeys.map(
			(key, index) =>
				(Cells[key] = {
					Value:
						key === 'Request Date' ||
						key === 'Create Date' ||
						key === 'Start Date'
							? prettyDateFormat(item[mainLevelValues[index]])
							: item[mainLevelValues[index]],
					Validation: {
						Key: true.toString(),
						Value: null,
						memberToValidateKey: null,
					},
				}),
		);

		// Generate Action Cells Array
		let ActionCellsArray = [
			{
				BindTo: 0,
				Checked: false,
				Key: nanoid(),
				Text: 'Toggle Selection',
				Type: ACTION_TYPES.CHECKBOX,
			},
		];

		item.Application.forEach((app, index) => {
			// Map through sub-level
			subLevelKeys.map(
				(key, index) =>
					(Cells[key] = {
						Value:
							// If the cell value is undefined, add empty string else add the value and a comma
							// This check is to cover instances when a request had multiple applications attached AND when it only has 1
							// Otherwise it may show up as 'undefined'
							key === 'ActionsAvailable'
								? app[subLevelValues[index]]
								: key === 'Application'
									? (Cells[key].Value !== undefined
											? Cells[key].Value + ','
											: '') +
										getAppNameWithoutAction(
											app[subLevelValues[index]]
												.split('-')
												.slice(1)
												.join('-')
												.trim(),
										)
									: key === 'ApplicationID'
										? (Cells[key].Value !== undefined
												? Cells[key].Value + ','
												: '') +
											app[
												subLevelValues[index]
											].toString() // convert this to string because it is the only value returned as int from API. Datatable expects to see string here
										: key === 'Unactionable'
											? Cells[key] !== ''
												? Cells[key].Value
												: app[subLevelValues[index]]
											: (Cells[key]?.Value !==
													undefined &&
												Cells[key]?.Value
													? Cells[key].Value + ','
													: '') +
												app[subLevelValues[index]],
						Validation: {
							Key: true.toString(),
							Value: null,
							memberToValidateKey: null,
						},
					}),
			);
		});

		// Create cell row and push to rows array
		let CellRow = {
			ActionCells: ActionCellsArray,
			Cells: Cells,
			isDisplayed: true,
			Key: nanoid(),
		};

		rowData.push(CellRow);
	});
	return rowData;
};
